import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_ERROR,
  SIGNUP_USER,
  SIGNUP_USER_SUCCESS,
  SIGNUP_USER_ERROR,
  CHECK_USER,
  CHECK_USER_SUCCESS,
  CHECK_USER_ERROR,
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  SIGNIN_USER_ERROR,
  LOGOUT_USER,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
} from "../actions";

const INIT_STATE = {
  loading: false,
  user: localStorage.getItem("user_id"),
  check: null,
  forgotPassword: "",
  resetPassword: "",
  error: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true, error: "" };
    case LOGIN_USER_SUCCESS:
      //console.log(action.payload);
      return {
        ...state,
        loading: false,
        user: action.payload._id,
        error: "",
      };

    case LOGIN_USER_ERROR:
      return {
        ...state,
        loading: false,
        user: "",
        error: action.payload.message,
      };

    case FORGOT_PASSWORD:
      return { ...state, loading: true, error: "" };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        forgotPassword: action.payload,
        error: "",
      };
    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        forgotPassword: "",
        error: action.payload.message,
      };
    case RESET_PASSWORD:
      //console.log("inside reducer");
      return { ...state, loading: true, error: "" };
    case RESET_PASSWORD_SUCCESS:
      // console.log("inside reducer success", action.payload);
      return {
        ...state,
        loading: false,
        resetPassword: action.payload,
        error: "",
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        resetPassword: "",
        error: action.payload.message,
      };

    case SIGNUP_USER:
      //console.log("inside reducer");
      return { ...state, loading: true, error: "" };
    case SIGNUP_USER_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        loading: false,
        user: action.payload,
        error: "",
      };

    case SIGNUP_USER_ERROR:
      return {
        ...state,
        loading: false,
        user: "",
        error: action.payload.message,
      };

    case CHECK_USER:
      return { ...state, check: null, loading: true, error: "" };
    case CHECK_USER_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        loading: false,
        check: action.payload,
        error: "",
      };

    case CHECK_USER_ERROR:
      return {
        ...state,
        loading: false,
        check: null,
        error: action.payload.message,
      };

    case SIGNIN_USER:
      //console.log("inside reducer");
      return { ...state, loading: true, error: "" };
    case SIGNIN_USER_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        loading: false,
        user: action.payload,
        error: "",
      };

    case SIGNIN_USER_ERROR:
      return {
        ...state,
        loading: false,
        user: "",
        error: action.payload.message,
      };

    case REGISTER_USER:
      //console.log("inside reducer");
      return { ...state, loading: true, error: "" };
    case REGISTER_USER_SUCCESS:
      //console.log(action.payload);
      return {
        ...state,
        loading: false,
        user: action.payload._id,
        error: "",
      };

    case REGISTER_USER_ERROR:
      return {
        ...state,
        loading: false,
        user: "",
        error: action.payload.message,
      };
    case LOGOUT_USER:
      return { ...state, user: null, error: "" };

    default:
      return { ...state };
  }
};
